"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(coinType) {
  return function (Origin) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(_class, _PureComponent);

      function _class(props) {
        var _this;

        _this = _PureComponent.call(this, props) || this;
        _this.state = {
          showCoin: props.coin
        };
        _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        return _this;
      }

      var _proto = _class.prototype;

      _proto.getValue = function getValue() {
        var showCoin = this.state.showCoin;
        var value = this.props.value;

        if (showCoin && (value || value === 0)) {
          return ("" + value).replace(/\d+/, function (n) {
            return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
              return $1 + ",";
            });
          });
        }

        if (value === 0) return 0;
        return ("" + (value || '')).replace(/,/g, '');
      };

      _proto.handleFocus = function handleFocus(e) {
        var onFocus = this.props.onFocus;
        this.isFocus = true;
        this.setState({
          showCoin: false
        });
        if (onFocus) onFocus(e);
      };

      _proto.handleBlur = function handleBlur(e) {
        var onBlur = this.props.onBlur;
        this.isFocus = false;
        if (!this.mouseDown) this.setState({
          showCoin: true
        });
        if (onBlur) onBlur(e);
      };

      _proto.handleMouseDown = function handleMouseDown(e) {
        var onMouseDown = this.props.onMouseDown;
        this.mouseDown = true;
        this.setState({
          showCoin: false
        });
        if (onMouseDown) onMouseDown(e);
      };

      _proto.handleMouseUp = function handleMouseUp(e) {
        var onMouseUp = this.props.onMouseUp;

        if (this.mouseDown && !this.isFocus) {
          this.setState({
            showCoin: true
          });
        }

        this.mouseDown = false;
        if (onMouseUp) onMouseUp(e);
      };

      _proto.render = function render() {
        var _this$props = this.props,
            coin = _this$props.coin,
            value = _this$props.value,
            onFocus = _this$props.onFocus,
            onBlur = _this$props.onBlur,
            others = _objectWithoutPropertiesLoose(_this$props, ["coin", "value", "onFocus", "onBlur"]);

        if (!coin) return _react.default.createElement(Origin, _extends({}, this.props, {
          coin: undefined
        }));
        if (coinType === 'input' && this.props.type !== 'number') return _react.default.createElement(Origin, _extends({}, this.props, {
          coin: undefined
        }));
        return _react.default.createElement(Origin, _extends({}, others, {
          onMouseDown: this.handleMouseDown,
          onMouseUp: this.handleMouseUp,
          value: this.getValue(),
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }));
      };

      return _class;
    }(_react.PureComponent), _defineProperty(_class, "propTypes", {
      value: _propTypes.default.any,
      type: _propTypes.default.string,
      coin: _propTypes.default.bool,
      onFocus: _propTypes.default.func,
      onBlur: _propTypes.default.func,
      onMouseDown: _propTypes.default.func,
      onMouseUp: _propTypes.default.func,
      onChange: _propTypes.default.func.isRequired
    }), _defineProperty(_class, "defaultProps", {
      coin: false
    }), _temp;
  };
};

exports.default = _default;